// external
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

// models
import { CallToActionPosition } from '@/interfaces/CallToActionTypes';
import MxrRetailer from '@/interfaces/MxrRetailer';
import { Partner } from '@/interfaces/Partner';
import { ProductShoppingListItem } from '@/interfaces/ProductShoppingListItem';
import { VuexAction } from '@/@types/index.d';

// store
import {
	GET_CURRENT_MXR_RETAILER,
	GET_FOOTER_BUTTON_CLICKED_REPORT,
	GET_IS_DEFAULT,
	GET_MXR_RETAILER_LOCATIONS,
	GET_SELECTED_PRODUCT_SHOPPING_LIST_ITEMS,
	GET_THIRD_TAB_CLICK_REPORT,
	SEND_REPORT,
	SET_CHECKOUT_TOTAL,
	SET_OFFERS_COUNT_IN_CART,
	GET_CARTING_URL,
} from '@/store/types';
import { IReport } from '@/interfaces/IReport';

@Component({})
export default class Walmart extends Vue {
	@Prop({ required: true }) label!: string;

	@Prop({ required: true }) position!: CallToActionPosition;

	@Prop() showCheckoutTotal!: boolean;

	@Prop() defaultUrl!: string;
	
	@Getter(GET_CARTING_URL) getCartingUrl!: string;

	@Getter(GET_IS_DEFAULT) getIsDefault!: boolean;

	@Getter(GET_CURRENT_MXR_RETAILER) getCurrentMxrRetailer!: MxrRetailer;

	@Getter(GET_SELECTED_PRODUCT_SHOPPING_LIST_ITEMS)
	getSelectedProductShoppingListItems!: ProductShoppingListItem[];

	@Getter(GET_MXR_RETAILER_LOCATIONS) getMxrRetailerLocations!: MxrRetailer[];

	@Getter(GET_THIRD_TAB_CLICK_REPORT) getThirdTabClickReport!: IReport;

	@Getter(GET_FOOTER_BUTTON_CLICKED_REPORT)
	getFooterButtonClickedReport!: IReport;

	@Action(SEND_REPORT) sendReport!: VuexAction<IReport>;

	@Action(SET_CHECKOUT_TOTAL) setCheckoutTotal: (
		payload: number
	) => VuexAction<void>;

	@Action(SET_OFFERS_COUNT_IN_CART) setOffersCountInCart: (
		payload: number
	) => VuexAction<void>;

	get price(): string {
		const prices: number[] = [];
		this.getSelectedProductShoppingListItems.forEach((p) => {
			const price = parseFloat(p.Price.substr(1, p.Price.length));
			if (!isNaN(price)) {
				prices.push(price);
			}
		});
		const total: string = prices.reduce((a, b) => a + b, 0).toFixed(2);
		this.setCheckoutTotal(Number.parseFloat(total));
		this.setOffersCountInCart(prices.length);
		return `Total: $${total}`;
	}

	get uri(): string {
		if (this.getMxrRetailerLocations.length === 0) {
			const walmartUri = new URL(this.defaultUrl);
			// console.log(`WMT: ${walmartUri.toString()}`);
			return walmartUri.toString();
		}

		const cartingUrl = this.getCartingUrl;
		return cartingUrl;
	}

	handleClick() {
		const report = this.getThirdTabClickReport;
		report.mxrThirdTabButtonClicked!.button = {
			label: this.label,
			partner: Partner.WALMART,
		};
		this.sendReport(report);
		this.sendReport(this.getFooterButtonClickedReport);
		try {
			if (!this.uri) {
				throw new Error('No carting URL');
			}
			window.open(this.uri, '_blank');
		} catch (error) {
			console.error('[WALMART CART]', error);
		}
	}
}
